/* eslint-disable radix */
import React from 'react';
import { withTranslation } from 'react-i18next';
import { BasicView } from '../containers/BasicView';
import { CollapseView } from '../containers/CollapseView';
import { StripesView } from '../containers/StripesView';
import { DeepLinkView } from '../containers/DeepLinkView';
import { Tabs } from '../containers/Tabs';
import { Tab } from '../containers/Tab';
import { Header } from '../containers/Header';
import wixService from '../../../../../services/wixService';
import { connect } from 'react-redux';
import { SearchView } from '../containers/SearchView';
import { BasicCategoriesTopBlock } from '../../../styles/basic';
import { toNumber } from 'lodash';
import EmptyState from '../../../../common/emptyState/emptyState';
import { editorXPadding } from '../../../styles';

class FixedHeight extends React.Component {
  constructor(props) {
    super(props);
    this.viewContainerRef = React.createRef();
    this.viewHeaderRef = React.createRef();
    this.viewTabsRef = React.createRef();
    this.viewQuestionListRef = React.createRef();
    this.viewFooterRef = React.createRef();
    this.state = {
      settings: props.settings,
      searchValue: '',
    };

    this.updateDimensions = this.updateDimensions.bind(this);
    this.getWindowDimensions = this.getWindowDimensions.bind(this);
    this.updateDimensions();
    this.resizeApp = this.resizeApp.bind(this);
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
  }

  resizeApp(width, height) {
    const added = this.state.searchValue !== '' ? 70 : 40;
    height = parseInt(height) + added;
    wixService.setHeight(height);
  }

  onChangeSearchValue(searchValue) {
    this.setState({ searchValue });
  }

  updateDimensions() {
    if (
      this.viewContainerRef &&
      this.viewContainerRef.current &&
      this.viewContainerRef.current.getBoundingClientRect()
    ) {
      const { width, height } =
        this.viewContainerRef.current.getBoundingClientRect();
      this.resizeApp(width, height);
      this.setState({ width, height });
    }
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  getWindowDimensions() {
    return {
      h: window.innerHeight,
      w: window.innerWidth,
    };
  }

  render() {
    const { settings, styleParams, design, deepLink, faqList, t } = this.props;
    const questionsDeepLink = [];
    const selectedCategories = settings.manageCategories.categories || [];

    if (wixService.isSiteMode() && deepLink.isEnable) {
      faqList.questions.forEach((q) => {
        if (q.id === deepLink.questionId) {
          questionsDeepLink.push(q);
        }
      });
    }

    const arrCategoriesWithQuestions = [];
    const LAST_CATEGORY_ID_FOR_MIGRATION = ['11111', '22222', '33333'];
    faqList.categories.map((item, index) => {
      if (!settings.manageCategories.showAll) {
        if (
          selectedCategories.indexOf(item.id) > -1 &&
          item.questionsList &&
          item.questionsList.length > 0
        ) {
          item.title =
            LAST_CATEGORY_ID_FOR_MIGRATION.includes(
              item.id.slice(item.id.length - 5),
            ) &&
            !(
              Math.abs(
                new Date(item.updatedDate) - new Date(item.createdDate),
              ) /
                36e5 >
              3
            )
              ? t('general') + toNumber(index + 1)
              : item.title;
          arrCategoriesWithQuestions.push(item);
        }
      } else {
        if (item.questionsList && item.questionsList.length > 0) {
          item.title =
            LAST_CATEGORY_ID_FOR_MIGRATION.includes(
              item.id.slice(item.id.length - 5),
            ) &&
            !(
              Math.abs(
                new Date(item.updatedDate) - new Date(item.createdDate),
              ) /
                36e5 >
              3
            )
              ? t('general') + toNumber(index + 1)
              : item.title;
          arrCategoriesWithQuestions.push(item);
        }
      }
      return item;
    });

    return (
      <div
        className={'mainContainer content flexbox-container' + editorXPadding}
      >
        {!arrCategoriesWithQuestions.length ? (
          <EmptyState
            isSiteMode={wixService.isSiteMode()}
            styleParams={styleParams}
            design={design}
            settings={settings}
          />
        ) : (
          <>
            <div className="flex-column box-header">
              <Header
                getWindowDimensions={this.getWindowDimensions}
                onChangeSearchValue={this.onChangeSearchValue}
              />
            </div>
            <>
              <>
                {this.state.searchValue !== '' && (
                  <>
                    <SearchView
                      searchValue={this.state.searchValue}
                      questions={faqList.questions}
                    />
                  </>
                )}
                {this.state.searchValue === '' && (
                  <>
                    {settings.isBasic && !settings.isDisplayCategoriesTop && (
                      <div
                        className="basic-view"
                        style={{ marginTop: '20px', width: 'calc(100%-8px)' }}
                      >
                        <>
                          {arrCategoriesWithQuestions.map((category, index) => {
                            return (
                              <div>
                                <BasicCategoriesTopBlock
                                  className="categories basic-categories"
                                  design={design}
                                  styleParams={styleParams}
                                >
                                  <h2 className="category">
                                    {' '}
                                    {category.title}
                                  </h2>
                                </BasicCategoriesTopBlock>
                                <BasicView
                                  className="question-basic-view"
                                  questions={category.questionsList}
                                />
                              </div>
                            );
                          })}
                        </>
                      </div>
                    )}
                    <>
                      {arrCategoriesWithQuestions.length > 0 &&
                        ((settings.isBasic &&
                          settings.isDisplayCategoriesTop) ||
                          settings.isCollapse ||
                          settings.isStripes) && (
                          <Tabs layout={settings.layout}>
                            {arrCategoriesWithQuestions.map(
                              (catItem, index) => {
                                return (
                                  <Tab title={catItem.title}>
                                    {settings.isBasic &&
                                      settings.isDisplayCategoriesTop && (
                                        <div
                                          className="basic-view"
                                          id={`basicItem_${index}`}
                                        >
                                          <BasicView
                                            className="question-basic-view"
                                            questions={catItem.questionsList}
                                          />
                                        </div>
                                      )}

                                    {settings.isStripes && (
                                      <div
                                        className="stripes-view margin-bottom30"
                                        id={`stripItem_${index}`}
                                        role="list"
                                      >
                                        <StripesView
                                          className="question-stripes-view"
                                          questions={catItem.questionsList}
                                        />
                                      </div>
                                    )}
                                    {settings.isCollapse && (
                                      <div
                                        className="collapse-view margin-bottom30"
                                        id={`collapseItem_${index}`}
                                      >
                                        <div id="accordion">
                                          {' '}
                                          <CollapseView
                                            questions={catItem.questionsList}
                                          />{' '}
                                        </div>
                                      </div>
                                    )}
                                  </Tab>
                                );
                              },
                            )}
                          </Tabs>
                        )}
                    </>
                  </>
                )}
              </>
            </>
            <div className="flex-column box-footer"></div>
            {deepLink.isEnable && questionsDeepLink.length > 0 && (
              <DeepLinkView questions={questionsDeepLink} />
            )}
          </>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(FixedHeight));
